// removed by extract-text-webpack-plugin
module.exports = {"people":"_2nWgh","prizesAndResults":"_1HZjV","noResults":"_2ck1i","prizes":"smH5w","results":"_2D5qc","resources":"UcB0C","root":"_14sfX","scheduleItem":"_1kovH","scheduleFlatItem":"_3Xx-h","timeline":"_1yFjs","emptyFirst":"_1C7xp","jumbo":"h06il","noSchedule":"_1inoP"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/pages/Show/style.sass
// module id = ./src/modules/Events/pages/Show/style.sass
// module chunks = 6